import './style.scss'
import React, {Component} from 'react'
import { FunctionMenu } from '../../components'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom';


class Dashboard extends Component {

	constructor(props){
		super(props)
		this.goUploadFile = this.goUploadFile.bind(this)
	}

	componentDidMount(){
		document.body.addEventListener('keydown',this.goUploadFile,false)
	}

	componentWillUnmount(){
		document.body.removeEventListener('keydown',this.goUploadFile,false)
	}

	goUploadFile(e){
		if(e.ctrlKey && e.altKey && e.keyCode === 49){
            this.props.history.replace( '/uploadFile')
		}
	}

	render() {
        const {currentAgent,location} = this.props
		return (
            <div className="dashboard">
                <div className="leftWidth">
                    <FunctionMenu currentAgent={currentAgent} />
                </div>
                <div className="rightWidth">
                    <div className="rightContent">
                        {/*  */}
                        {/* {location.pathname.search('/workBench') != -1 && <WorkBenchLeftContent />} */}

                        {/*  */}
                        {this.props.children}
                    </div>
                </div>
            </div>
        );
	}
}

let mapStateToProps = (state) => {
	return {
        currentAgent: state.app.currentAgent.userInfo,
	}
};

let mapDispatchToProps = (dispatch) => {
    return { actions: bindActionCreators(Object.assign({},

    ), dispatch)
    }
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(withRouter(Dashboard))
